import { useState } from 'react'
import { ArrowLeft, CheckCircle2, Download, XCircle } from 'lucide-react'
import toast from 'react-hot-toast'
import { downloadDocument } from '../../utils/compliance/commonUtil'

export default function ResultCard({ jobId, jobData, jobType = 'smp', error, onReset }) {
  const [downloading, setDownloading] = useState(false)
  const isSuccess = !error
  const isRaid    = jobType === 'raid'
  const isTvr     = jobType === 'tvr'
  const isObligation = jobType === 'obligation'
  const isStm     = jobType === 'stm'
  const isRtm     = jobType === 'rtm'

  const lastLog    = jobData?.logs?.at(-1)?.replace(/^\[.*?\]\s*/, '') ?? ''
  const baseName   = (jobData?.sow_filename ?? 'Generated').replace(/\.[^.]+$/, '')
  const dlFilename = isObligation ? `OBLIGATION_${baseName}.xlsx` : isRtm ? `RTM_${baseName}.xlsx` : isStm ? `STM_${baseName}.xlsx` : isTvr ? `TVR_${baseName}.xlsx` : isRaid ? `RAID_${baseName}.xlsx` : `SMP_${baseName}.docx`
  const dlLabel    = isObligation ? 'Download Obligations Tracker' : isRtm ? 'Download Requirements Traceability Matrix' : isStm ? 'Download Service Traceability Matrix' : isTvr ? 'Download TVR Tracker' : isRaid ? 'Download RAID Tracker' : 'Download SMP Document'
  const successMsg = isObligation ? 'Obligations Tracker Generated Successfully!' : isRtm ? 'Requirements Traceability Matrix Generated Successfully!' : isStm ? 'Service Traceability Matrix Generated Successfully!' : isTvr ? 'TVR Tracker Generated Successfully!' : isRaid ? 'RAID Tracker Generated Successfully!' : 'SMP Generated Successfully!'
  const resetLabel = isObligation ? '↩  Analyse another SOW' : isRtm ? '↩  Analyse another document' : isStm || isTvr || isRaid ? '↩  Analyse another SOW' : '↩  Generate another SMP'

  async function handleDownload() {
    setDownloading(true)
    try {
      await downloadDocument(jobId, dlFilename)
    } catch (err) {
      if (err?.message) toast.error(err.message)
    } finally {
      setDownloading(false)
    }
  }

  return (
    <div className="c-card">
      <div className={`c-result-banner${error ? ' is-error' : ''}`}>
        <span className="c-result-icon">
          {isSuccess ? <CheckCircle2 size={22} /> : <XCircle size={22} />}
        </span>
        <div className="c-result-body">
          <h3>{isSuccess ? successMsg : 'Generation Failed'}</h3>
          <p>{error ?? lastLog ?? 'Your file is ready to download.'}</p>
        </div>
      </div>

      {isSuccess && (
        <button className="c-btn-download" onClick={handleDownload} disabled={downloading}>
          {downloading
            ? <><span className="c-spinner c-spinner-white" />&nbsp;Downloading…</>
            : <><Download size={14} />&nbsp;{dlLabel}</>
          }
        </button>
      )}

      <button className="c-btn-secondary" onClick={onReset}>
        <ArrowLeft size={13} />&nbsp;{resetLabel.replace(/^↩\s*/, '')}
      </button>
    </div>
  )
}
